import { Language } from "./context";

export const getInitialLang = () => {
  try {
    const savedLang = localStorage.getItem(Language.LANG);
    if (savedLang) return savedLang;

    const browserLang = (
      navigator.language ||
      navigator.userLanguage ||
      ""
    ).toLowerCase();

    const lang = browserLang.startsWith("ko")
      ? Language.KOREAN
      : Language.ENGLISH;
    localStorage.setItem(Language.LANG, lang);

    return lang;
  } catch (e) {
    // fallback
    return Language.ENGLISH;
  }
};
